export default __webpack_public_path__ + "6c3dc39249ca56b91b230a63d30a317b.jpg";